import GlobalLogin from "@/components/CustomLogin/index.vue";

const GlobalLoginPlugin = {
  install(Vue) {
    // 创建组件实例
    const GlobalLoginConstructor = Vue.extend(GlobalLogin);
    const instance = new GlobalLoginConstructor();
    // 手动挂载
    instance.$mount();
    document.body.appendChild(instance.$el);
    // 添加全局方法
    Vue.prototype.$login = (options = {}) => {
      return instance.show(options);
    };
    // 添加全局属性（可选）
    Vue.prototype.$globalLogin = instance;
  },
};

export default GlobalLoginPlugin;
